import { object, string } from "yup";

export const profileValidationSchema = object({
  name         : string().required("Name is required"),
  phone_number : string()
    .matches(new RegExp(/^(\+|\d)[0-9]{7,16}$/), "Invalid phone number")
    .nullable(),
  timezone: object().nullable().required("Timezone is required"),
});
